import styled from "styled-components";

const ModalContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 400px;
  position: absolute;
  z-index: 9999;
`

export const WindowControl = styled.div`
  background: RGBA(217, 217, 217, 0.69);
  border-radius: 8px 8px 0 0;
  padding: 10px;
  cursor: all-scroll;
  width: 100%;
  align-self: center;
`
export const WindowControlBottom = styled.div`
  background: RGBA(217, 217, 217, 0.69);
  border-radius: 0 0 8px 8px;
  padding: 30px;
  cursor: all-scroll;
  width: 100%;
  align-self: flex-end;
`

export default ModalContainer;
